<!-- 画面右上に固定表示するトーストスタック。aria-live でスクリーンリーダーにも通知する -->
<div
  class="pointer-events-none fixed right-4 top-4 z-[100] flex w-80 flex-col gap-2"
  aria-live="polite"
  role="status"
>
  @for (toast of toasts(); track toast.id) {
    <div
      class="pointer-events-auto flex animate-in items-start gap-3 rounded-xl border p-4 shadow-lg fade-in slide-in-from-top-2 duration-200"
      [class]="toastClass(toast.type)"
    >
      <lucide-icon [name]="toastIcon(toast.type)" [size]="20" class="mt-0.5 shrink-0"></lucide-icon>
      <p class="flex-1 text-sm font-medium">{{ toast.message }}</p>
      <button
        type="button"
        (click)="dismiss(toast.id)"
        aria-label="閉じる"
        class="shrink-0 rounded p-0.5 transition-colors hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-current"
      >
        <lucide-icon name="x" [size]="16"></lucide-icon>
      </button>
    </div>
  }
</div>
